import { render, staticRenderFns } from "./CCureTask.vue?vue&type=template&id=6473346b"
import script from "./CCureTask.vue?vue&type=script&lang=ts"
export * from "./CCureTask.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports